import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b9f23aac")

_pushScopeId("data-v-b9f23aac")
const _hoisted_1 = { class: "horizontal-list" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = { class: "pager" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_HLine = _resolveComponent("HLine")
  const _component_fa = _resolveComponent("fa")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h2", _hoisted_2, [
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode("span", {
        class: "link",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.headerLinkAction && _ctx.headerLinkAction(...args)))
      }, _toDisplayString(_ctx.headerLinkText), 1)
    ]),
    _createVNode(_component_HLine),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", { inPageItems: _ctx.inPageItems }, undefined, true)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args))),
          disabled: !_ctx.canPrev
        }, [
          _createVNode(_component_fa, { icon: ['fas', 'chevron-left'] })
        ], 8, ["disabled"]),
        _createVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
          disabled: !_ctx.canNext
        }, [
          _createVNode(_component_fa, { icon: ['fas', 'chevron-right'] })
        ], 8, ["disabled"])
      ])
    ])
  ]))
})